<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <form @submit="onSubmit">
            <div class="row">
                <b-form-group
                  class="col-12 col-sm-6 mb-3"
                  label="Nombre"
                >
                  <b-form-input
                    v-model="document.name"
                    type="text"
                    placeholder="Nombre del documento"
                    :state="validate(document.name)"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  class="col-12 col-sm-6 mb-3"
                >
                  <template #label>
                    <b-icon icon="lock" class="mx-1" font-scale="1" ></b-icon>
                  </template>
                  <b-form-checkbox
                    v-model="document.confidential"
                  >
                    <div class="p-0 mx-1">El documento es confidencial</div>
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  class="col-12 col-sm-6 mb-3"
                  label="Tipo de documento"
                >
                    <b-form-select
                      class="form-select"
                      v-model="tipoDocumentoSelected"
                      :options="tiposdocumentos"
                      :state="validate(tipoDocumentoSelected)"
                    >
                        <template #first>
                            <option value="" disabled>-- Seleccione un tipo de documento --</option>
                        </template>
                    </b-form-select>
                </b-form-group>
                
                <div class="col-sm-6 mb-3">
                    <label for="fileInput">Archivo</label>
                    <input 
                        type="file" 
                        :class="fileClass"  
                        id="fileInput" 
                        ref="fileInput" 
                        @change="handleFileChange" 
                        accept=".pdf,application/pdf"
                    />
                </div>

                <b-form-group
                  class="col-12 col-sm-6 mb-3"
                  label="Seleccione los destinatarios"
                >
                    <b-form-select
                        v-model="destinatariosSelected"
                        class="form-select"
                        :options="destinatarios"
                        multiple
                        :select-size="6"
                        :state="validate(destinatariosSelected)"
                    >

                    </b-form-select>
                </b-form-group>
           </div>

            <div class="row">
                <div class="col-auto">
                    <button type="submit" class="btn btn-outline-primary" :disabled="process">
                        <b-spinner v-if="process" small/>
                        Crear
                    </button>
                </div>
                <div class="col-10">
                    <ProgressCustom ref="progressCustom"></ProgressCustom>
                </div>
            </div>

        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import ProgressCustom from '@/components/shared/Progress-custom.vue';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { validateNonEmpty } from '@/plugins/complianceScripts';

export default {
    name: 'DocumentForm',

    data() {
        return {
            destinatariosSelected: [],
            destinatarios: [],

            tipoDocumentoSelected: '',
            tiposdocumentos: [],

            document: {
                name: '',
                confidential: false
            },

            file: null,

            process: false,
            attemptedSubmit: false,
        }
    },

    components: {
        AlertDismiss,
        ProgressCustom
    },

    async mounted() {
        await this.getDocumentTypes();
        await this.getDestinations();
    },

    computed: {
        allValuesFilled() {
            return this.document.name !== '' &&
                this.tipoDocumentoSelected !== '' &&
                this.file !== null &&
                this.destinatariosSelected.length > 0
        },

        fileClass() {
            let valid = this.attemptedSubmit && !this.file ? 'is-invalid' : ''
            return 'form-control mt-2 ' + valid
        }
    },
        

    methods: {
        validate(value) {
            return validateNonEmpty(value, this.attemptedSubmit);
        },
        ...mapActions(["allDocumentType", "allDestination", "uploadFileDocument", "saveDocument"]),

        async onSubmit(event) {
            event.preventDefault();
            this.attemptedSubmit = true
            if (!this.allValuesFilled) {
                this.$refs.alertDismiss.showAlert('Debe completar todos los campos', 'warning');
                return
            }
            this.attemptedSubmit = false

            let route = await this.uploadDocumentFile();
            if (route === null) {
                return;
            }

            await this.saveDocumentData(route);

            // emitimos el evento para actualizar la tabla
            this.$eventBus.$emit(EventNames.CreateDocument, {
                page: 1,
                pageSize: InitPageSize.UsersPageSize
            });
        },

        processing() {
            this.process = !this.process;
        },

        reset() {
            this.destinatariosSelected = [];
            this.tipoDocumentoSelected = "";

            this.document.confidential = false;
            this.document.name = '';

            this.file = null;
            this.$refs.fileInput.value = null

            this.$refs.progressCustom.progress(0, '');
        },

        async getDocumentTypes() {
            this.processing();
            let documentType = await this.allDocumentType();

            if (documentType.isError) {
                this.$refs.alertDismiss.showAlert(documentType.message);
                this.processing();
                return;
            }

            this.tiposdocumentos = documentType.data.map((type) => {
                return { value: type.id, text: type.name }
            });

            this.processing();
        },

        async getDestinations() {
            this.processing();
            let result = await this.allDestination();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.processing();
                return;
            }

            this.destinatarios = result.data.map((d) => {
                return { value: d.id, text: d.name }
            });

            this.processing();
        },

        async uploadDocumentFile() {
            this.processing();

            if (this.file === null) {
                this.$refs.alertDismiss.showAlert('Debe cargar el archivo.');
                this.$refs.progressCustom.progress(0, '');
                this.processing();
                return null;
            }

            this.$refs.progressCustom.progress(5, 'Procesando petición documento');

            let result = await this.uploadFileDocument(this.file);

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.$refs.progressCustom.progress(0, '');
                this.processing();
                return null;
            }

            this.$refs.progressCustom.progress(50, 'Documento guardado correctamente');
            this.processing();
            return result.data;
        },

        async saveDocumentData(route) {
            this.processing();
            this.$refs.progressCustom.progress(55, 'Procesando petición de datos');

            let destinatarios = this.destinatariosSelected.map((x) => {
                return {
                    id: x
                }
            })

            let data = {
                name: this.document.name,
                typeId: this.tipoDocumentoSelected,
                route: route,
                confidential: this.document.confidential,
                rolesDestinations: destinatarios
            };

            let result = await this.saveDocument(data);

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.$refs.progressCustom.progress(0, '');
                this.processing();
                return;
            }

            this.$refs.progressCustom.progress(100, 'Exito en el proceso');
            this.processing();

            // Simular una espera de 4 segundos
            this.$refs.alertDismiss.showAlert('Documento creado correctamente', 'success');
            this.reset();
        },


        handleFileChange(event) {
          const file = event.target.files[0]
          if (file) {
            this.file = file
          }
        },
    },
}
</script>
<style scoped>
/* hide label.custom-file-label */
.custom-file-label {
  display: none;
}
</style>
